import React, { useEffect, useState } from 'react';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { Dashboard as DashboardLayout } from 'layouts';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';
import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { showLastUpdateRates } from 'js/actions/controlRateActions';
import PropTypes from 'prop-types';
import { isAllowed } from 'helpers';
import { GetFee, UploadFee } from './components';
const useStyles = makeStyles(styles);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function ControlRate() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const { last_update } = useSelector((state) => state.controlRate);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(showLastUpdateRates());
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <DashboardLayout title="Buscador Tarifario">
      <div className={classes.root}>
        <div className={classes.content}>
          <Portlet>
            <PortletHeader noDivider={true}>
              <PortletLabel
                title={intl.formatMessage({ id: 'app.feeCtrl.title' })}
              />
            </PortletHeader>
            <PortletContent>
              <div className={classes.device}>
                <div className={classes.device}>
                  <Typography variant="h2">
                    {intl.formatMessage({ id: 'app.feeCtrl.dateLbl' })}
                  </Typography>
                  <Typography variant="h1" sx={{ color: 'secondary.main' }}>
                    {last_update}
                  </Typography>
                </div>
              </div>
            </PortletContent>
          </Portlet>
          <Box sx={{ bgcolor: 'background.paper', mt: 3 }}>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                aria-label="full width tabs example"
                indicatorColor="secondary"
                textColor="inherit"
                sx={{
                  bgcolor: 'secondary.main',
                  '& .MuiTabs-indicator': { backgroundColor: 'white' },
                }}
              >
                <Tab
                  label={intl.formatMessage({ id: 'app.feeCtrl.feeCtrlLnk' })}
                  {...a11yProps(0)}
                  sx={{
                    textTransform: 'capitalize',
                    fontSize: '1.125rem',
                    '&.Mui-selected': {
                      color: 'white',
                      backgroundColor: 'rgb(0, 146, 199)',
                      borderRadius: 1,
                    },
                    '&:hover': {
                      backgroundColor: 'rgb(0, 146, 199)',
                      borderRadius: 1,
                    },
                  }}
                />
                {isAllowed(user.permissions, ['tariff_create']) && (
                  <Tab
                    label={intl.formatMessage({
                      id: 'app.feeCtrl.feeCtrlManLnk',
                    })}
                    {...a11yProps(1)}
                    sx={{
                      textTransform: 'capitalize',
                      fontSize: '1.125rem',
                      '&.Mui-selected': {
                        color: 'white',
                        backgroundColor: 'rgb(0, 146, 199)',
                        borderRadius: 1,
                      },
                      '&:hover': {
                        backgroundColor: 'rgb(0, 146, 199)',
                        borderRadius: 1,
                      },
                    }}
                  />
                )}
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <GetFee />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <UploadFee />
            </TabPanel>
          </Box>
        </div>
      </div>
    </DashboardLayout>
  );
}
